const datePattern = /^\d{4}-\d{2}-\d{2}$/;

/** UTC-midnight timestamp of a valid `YYYY-MM-DD` calendar date, else null. */
export const utcDay = (value: string | null | undefined): number | null => {
  if (!value || !datePattern.test(value)) return null;
  const timestamp = Date.parse(`${value}T00:00:00.000Z`);
  if (!Number.isFinite(timestamp) || new Date(timestamp).toISOString().slice(0, 10) !== value) return null;
  return timestamp;
};
